import { Page } from "~/v2/components/Page";
import { LegacyAddWhitelistAddressModal } from "~/v2/pages/dashboard/coinTransfers/legacyAddWhitelistAddress";
import { Path } from "~/v2/path";
import { TransferCard } from "../coinTransfers/TransferCard";
import { TransfersTable } from "../coinTransfers/TransfersTable/TransfersTable.connector";
import { WhitelistTable } from "../coinTransfers/WhitelistTable/WhitelistTable.connector";
import type { DigitalAssetTransfersControllerReturn } from "./DigitalAssetTransfers.controller";

export interface DigitalAssetTransfersPresProps
  extends DigitalAssetTransfersControllerReturn {}

export const DigitalAssetTransfersPresentation = ({
  account,
  accountId,
  product,
  isLoading,
  isFetchingEnabled,
  legacyAddWhitelistAddress,
  isTRCEnabled,
  onAddWhitelistAddressClicked,
}: DigitalAssetTransfersPresProps) => (
  <Page title="Digital Assets Transfers" className="pt-2 pb-20 sm:pb-4">
    <div className="flex w-full flex-col gap-6 md:grid md:grid-cols-[auto_357px] md:grid-rows-[auto_auto]">
      <div className="flex flex-col gap-4">
        <TransfersTable
          accountId={accountId}
          isLoading={isLoading}
          isFetchingEnabled={isFetchingEnabled}
        />
        <WhitelistTable
          accountId={accountId}
          isLoading={isLoading}
          isFetchingEnabled={isFetchingEnabled}
          isTRCEnabled={isTRCEnabled}
          whitelistAddressPath={Path.ROUTE_DIGITAL_ASSETS_WHITELIST_ADDRESS}
          onAddWhitelistAddressClicked={onAddWhitelistAddressClicked}
        />
      </div>
      <section className="w-full">
        <TransferCard
          account={account}
          accountId={accountId}
          product={product}
          isFetchingEnabled={isFetchingEnabled}
          onAddWhitelistAddressClicked={onAddWhitelistAddressClicked}
        />
      </section>
    </div>

    <LegacyAddWhitelistAddressModal {...legacyAddWhitelistAddress} />
  </Page>
);
